import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { login } from '../firebase/auth';
import { Link } from 'react-router-dom';
import Logo from "../SmartViewMD.com.svg"
import './Login.scss';

function Login(props) {
  const { register, handleSubmit, reset } = useForm();
  const [isLoading, setLoading] = useState(false);

  const routeOnLogin = async (user) => {
    const token = await user.getIdTokenResult();
    console.log('token: ', token);
    if (token.claims.admin) {
      props.history.push('/users');
    } else {
      if (token.claims.doctor) {
        props.history.push('/patients');
      } else {
        props.history.push(`/reading/${user.uid}`);
      }
    }
  };

  const onSubmit = async (data) => {
    let user;
    setLoading(true);
    try {
      user = await login(data);
      reset();
    } catch (error) {
      console.log(error);
    }

    if (user) {
      routeOnLogin(user);
    } else {
      setLoading(false);
    }
  };

  const formClassName = `ui form ${isLoading ? 'loading' : ''}`;

  return (
    <>
      {/* Old Code For reference */}
      {/* <div className="login-container">
        <div className="ui card login-card">
          <div className="content">
            <form className={formClassName} onSubmit={handleSubmit(onSubmit)}> 
              <div className="field">
                <label>
                  Email
                  <input
                    type="email"
                    name="email"
                    placeholder="Email"
                    ref={register}
                  />
                </label>
              </div>
              <div className="field">
                <label>
                  Password
                  <input
                    type="password"
                    name="password"
                    placeholder="Password"
                    ref={register}
                  />
                </label>
              </div>
              <div className="field actions">
                <button className="ui primary button login" type="submit">
                  Login
                </button>
                or
                <Link to="/signup">Sign Up</Link>
                {" "}|
                <Link to="/resetpw">Reset Password</Link>
              </div>
            </form>
          </div>
        </div>
      </div> */}

      <div className="login__body">
        <div className="login__container">
          <div className="login__header">
            <img
              className="login__logo"
              src={Logo}
              alt="Smartview"
            />
            <h2 className="login__title">Sign in to your account</h2>
          </div>

          <div className="login__form-wrapper">
            <div className="login__form-box">
              <form className={`login__form ${formClassName}`} onSubmit={handleSubmit(onSubmit)}>
                <div className="login__field">
                  <label htmlFor="email" className="login__label">Email address</label>
                  <input
                    type="email"
                    name="email"
                    id="email"
                    autoComplete="email"
                    required
                    className="login__input"
                    ref={register}
                  />
                </div>

                <div className="login__field">
                  <div className='login__label-container'>
                    <label htmlFor="password" className="login__label">Password</label>
                    <div className="login__options">
                      <div className="login__forgot">
                        <Link className="login__link" to="/resetpw">Reset Password</Link>
                      </div>
                    </div>
                  </div>
                  <input
                    type="password"
                    name="password"
                    id="password"
                    autoComplete="current-password"
                    required
                    className="login__input"
                    ref={register}
                  />
                </div>
                {/* 
                <div className="login__options">
                  <div className="login__forgot">
                    <Link className="login__link" to="/resetpw">Reset Password</Link>
                  </div>
                </div> */}

                <div>
                  <button type="submit" className="login__button ">Sign in</button>
                </div>
              </form>
            </div>

            <p className="login__footer">
              Don’t have an account?{' '}
              <Link className='login__link' to="/signup">Sign Up</Link>
            </p>
          </div>
        </div>
      </div>

    </>
  );
}

export default Login;
